import React from "react";
import styled from "styled-components";
import {Button} from "@material-ui/core";
import {Colors} from "../../theme/colors";

export const StyledButton: React.FC<StyledButtonProps> = ({type, color = 'violet', onClick, children, style, disabled = false}) => {
    let backgroundColor = Colors.primary70;
    let hoverBackgroundColor = Colors.primary70;
    let buttonColor = Colors.secondary10;
    let borderColor = Colors.primary70;

    if (color === 'blue') {
        backgroundColor = Colors.lightBlue;
        hoverBackgroundColor = Colors.blue;
    } else if (color === 'orange') {
        backgroundColor = Colors.orange;
        hoverBackgroundColor = Colors.darkOrange;
    } else if (color === 'pink') {
        backgroundColor = Colors.pink;
        hoverBackgroundColor = Colors.pink;
    } else if (color === 'transparent') {
        backgroundColor = 'transparent';
        hoverBackgroundColor = 'transparent';
        buttonColor = '#000';
        borderColor = '#E0E0E0';
    } else if (color === 'red') {
        backgroundColor = Colors.dangerRed;
        hoverBackgroundColor = Colors.dangerRedHover;
    } else if (color === 'transparentViolet') {
        backgroundColor = 'transparent';
        hoverBackgroundColor = 'transparent';
        buttonColor = Colors.violet;
        borderColor = Colors.extraLightViolet;
    } else if (color === 'primary') {
        backgroundColor = Colors.primary70;
        buttonColor = Colors.secondary10;
        hoverBackgroundColor = Colors.primary70;
        borderColor = Colors.primary70;
    } else if (color === 'secondary') {
        backgroundColor = Colors.secondary70;
        buttonColor = Colors.secondary10;
        hoverBackgroundColor = Colors.secondary70;
        borderColor = Colors.secondary70;
    }

    return (
        <StyleButton
            backgroundColor={backgroundColor}
            hoverBackgroundColor={hoverBackgroundColor}
            borderColor={borderColor}
            type={type}
            variant="contained"
            onClick={(event) => { if (onClick) {onClick(event);} }}
            style={style}
            color={buttonColor}
            disabled={disabled}
        >
            {children}
        </StyleButton>
    )
}

const StyleButton = styled(({ backgroundColor, hoverBackgroundColor, color, borderColor, ...rest }) => <Button {...rest} />)<StyleProps>`
  background-color: ${props => props.backgroundColor};
  color: ${props => props.color};
  box-shadow: none;
  border: 1px solid ${props => props.borderColor};
  border-radius: 12px;
  font-family: 'Poppins';
  font-size: 1rem;
  font-weight: 600;
  padding: 0.6rem 1.4rem;

  &:hover {
    background: ${props => props.hoverBackgroundColor};
    box-shadow: none;
  }
`;

export interface StyledButtonProps {
    type: 'button'|'submit';
    color?: 'violet'|'blue'|'orange'|'pink'|'transparent'|'red'|'transparentViolet'|'primary'|'secondary';
    onClick?: Function;
    style?: any;
    disabled?: boolean;
}

interface StyleProps {
    backgroundColor: string;
    hoverBackgroundColor: string;
    borderColor: string;
    color: string;
}
